import React, { useState } from "react";
import {
  Upload,
  Button,
  Typography,
  Space,
  Input,
  Select,
  Row,
  Col,
  Form,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Text, Link } = Typography;
const { Option } = Select;

const UploadSection = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [view, setView] = useState("upload"); // upload | fileReady | manual

  const uploadProps = {
    beforeUpload: (file) => {
      setSelectedFile(file);
      return false;
    },
    showUploadList: false,
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8f9fb" }}>
      {/* Upload Screen */}
      {view === "upload" && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            textAlign: "center",
          }}
        >
          <div>
            <Text strong>Upload File</Text>
            <div
              style={{
                border: "1px dashed #d9d9d9",
                borderRadius: "8px",
                padding: "40px",
                marginTop: "10px",
                marginBottom: "20px",
                width: "300px",
                backgroundColor: "#fff",
              }}
            >
              <Upload {...uploadProps}>
                <PlusOutlined style={{ fontSize: "32px", color: "#52c41a" }} />
              </Upload>
              {selectedFile && (
                <div style={{ marginTop: "10px", fontSize: "13px" }}>
                  Selected: {selectedFile.name}
                </div>
              )}
            </div>

            <Space direction="vertical" size="middle">
              <Button
                type="primary"
                style={{ backgroundColor: "#009688", borderColor: "#009688" }}
                onClick={() => {
                  if (selectedFile) {
                    setView("fileReady");
                  } else {
                    alert("Please select a file first!");
                  }
                }}
              >
                Upload File
              </Button>
              <Link href="#" style={{ fontSize: "13px" }}>
                Download Sample Format
              </Link>
              <Button
                type="primary"
                style={{ backgroundColor: "#6a1b9a", borderColor: "#6a1b9a" }}
                onClick={() => setView("manual")}
              >
                Add Data Manually
              </Button>
            </Space>
          </div>
        </div>
      )}

      {/* File Ready Screen */}
      {view === "fileReady" && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            textAlign: "center",
          }}
        >
          <div>
            <Text strong>File Ready to be populated</Text>
            <div
              style={{
                border: "1px dashed #d9d9d9",
                borderRadius: "8px",
                padding: "40px",
                marginTop: "10px",
                marginBottom: "20px",
                width: "300px",
                backgroundColor: "#fff",
              }}
            >
              <PlusOutlined style={{ fontSize: "32px", color: "#52c41a" }} />
              <div>
                <a href="#">{selectedFile?.name}</a>
              </div>
              <div style={{ fontSize: "12px", color: "#1890ff" }}>
                total 2300 Rows
              </div>
            </div>

            <Space direction="vertical" size="middle">
              <Button
                type="primary"
                style={{ backgroundColor: "#009688", borderColor: "#009688" }}
              >
                Start Process
              </Button>
              <Link
                href="#"
                onClick={() => {
                  setSelectedFile(null);
                  setView("upload");
                }}
                style={{ fontSize: "13px" }}
              >
                Reupload
              </Link>
            </Space>
          </div>
        </div>
      )}

      {/* Manual Form Screen */}
      {view === "manual" && (
        <div
          style={{
            padding: "40px",
            minHeight: "100vh",
            backgroundColor: "#fff",
          }}
        >
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
  <Text
    strong
    style={{
      fontSize: "18px",
      color: "#2A72E5",
      backgroundColor: "#f3e5f5",
      padding: "8px 30px",
      borderRadius: "20px",
      display: "inline-block",
    }}
  >
    Manual Details
  </Text>
</div>

          <Form layout="vertical">
            <Row gutter={[24, 24]}>
              <Col span={8}>
                <Form.Item label="Indent Month" name="indentMonth">
                  <Input placeholder="Indent Month" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Select District" name="district">
                  <Select placeholder="Select District">
                    <Option value="district1">District 1</Option>
                    <Option value="district2">District 2</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Select MSCP" name="mscp">
                  <Select placeholder="Select MSCP">
                    <Option value="mscp1">MSCP 1</Option>
                    <Option value="mscp2">MSCP 2</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Project Name" name="project">
                  <Input placeholder="Project Name" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="6m to 3y" name="6mto3y">
                  <Input placeholder="6m to 3y" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="6m to 3y SAM" name="6mto3ySam">
                  <Input placeholder="6m to 3y SAM" />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="3y to 6y" name="3yto6y">
                  <Input placeholder="3y to 6y" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="3y to 6y SAM" name="3yto6ySam">
                  <Input placeholder="3y to 6y SAM" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="P/L/AW" name="plaw">
                  <Input placeholder="P/L/AW" />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Adults & Girls" name="adultsGirls">
                  <Input placeholder="Adults & Girls" />
                </Form.Item>
              </Col>
            </Row>
          </Form>

          {/* Footer */}
          <div style={{ textAlign: "center", marginTop: "30px" }}>
            <Button
              type="primary"
              style={{
                backgroundColor: "#6a1b9a",
                borderColor: "#6a1b9a",
                padding: "0 40px",
              }}
            >
              Save & Proceed
            </Button>
            </div>
            </div>
          
        
      )}
    </div>
  );
};

export default UploadSection;
